import {
  PRICE_ALERTS_SUCCESS,
  PRICE_ALERTS_ERROR,
  PRICE_ALERT_FETCH,
  PRICE_ALERT_SUCCESS,
  PRICE_ALERT_ERROR,
} from '../../actions/priceAlerts/priceAlertsActionConstants';
import createReducer from '../../utils/createReducer';

const initialState = {
  data: [],
  priceAlert: null,
  errorMessage: '',
};

export default createReducer(
  {
    [PRICE_ALERTS_SUCCESS]: priceAlertsSuccess,
    [PRICE_ALERTS_ERROR]: priceAlertsError,
    [PRICE_ALERT_FETCH]: priceAlertFetch,
    [PRICE_ALERT_SUCCESS]: priceAlertSuccess,
    [PRICE_ALERT_ERROR]: priceAlertError,
  },
  initialState,
);

function priceAlertFetch(state) {
  // Clear out the previous single-alert response immediately so a
  // component reading this slot while a new fetch is in flight can't
  // mistake a stale, unrelated (or previously-edited) alert's data for the
  // one it's currently requesting.
  return {
    ...state,
    priceAlert: null,
  };
}

function priceAlertsSuccess(state, action) {
  const { payload, productCode } = action;
  if (!productCode) {
    return {
      ...state,
      data: payload,
      errorMessage: '',
    };
  }
  return {
    ...state,
    data: [
      ...state.data.filter((alert) => alert.ProductCode !== productCode),
      ...payload,
    ],
    errorMessage: '',
  };
}

function priceAlertsError(state, action) {
  return {
    ...state,
    errorMessage: action.payload,
  };
}

function priceAlertSuccess(state, action) {
  return {
    ...state,
    priceAlert: action.payload,
    errorMessage: '',
  };
}

function priceAlertError(state, action) {
  return {
    ...state,
    errorMessage: action.payload,
  };
}
